import { FlexAlign, FlexJustify, StackHorizontal, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';

function Renew() {
	const { t } = useTranslation();

	return (
		<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-xs'>
			<h2 className='mb-0'>{t('settings.renew.title')}</h2>
		</StackHorizontal>
	);
}

export { Renew };
